import { useEffect, useState } from 'react';
import { useAccessToken } from '../auth/use-access-token.js';
import { practiceCalls, type Practice, type PracticeSummary } from './practices.js';

export type PracticesState =
  | { status: 'loading' }
  | { status: 'ready'; summary: PracticeSummary; practices: Practice[] }
  | { status: 'failed'; message: string };

/** One athlete's practices; null for the athlete signed in. */
export function usePractices(athleteClientId: string | null): PracticesState {
  const getToken = useAccessToken();
  const [state, setState] = useState<PracticesState>({ status: 'loading' });
  useEffect(() => {
    let live = true;
    setState({ status: 'loading' });
    practiceCalls
      .list(getToken, athleteClientId)
      .then((found) => live && setState({ status: 'ready', ...found }))
      .catch((cause: unknown) => live && setState({ status: 'failed', message: cause instanceof Error ? cause.message : 'That did not work. Try again.' }));
    return () => {
      live = false;
    };
  }, [getToken, athleteClientId]);
  return state;
}
